import RadioButton from "@medoma/components/RadioButton/RadioButton";
import RadioButtons from "@medoma/components/RadioButton/RadioButtons";
import { useFormContext } from "react-hook-form";
import { useLingui } from "@lingui/react/macro";
import {
  activityFrequencyDictionary,
  activityFrequencySchema,
  type IActivityFrequency,
} from "./schedulingModels";

export type IFrequencyPickerFields = {
  frequency: IActivityFrequency;
};

export const FrequencyPicker = () => {
  const {
    formState: { errors },
    register,
  } = useFormContext<IFrequencyPickerFields>();

  const { t } = useLingui();

  const frequencyField = register("frequency", {
    required: {
      value: true,
      message: t`Sätt upprepningsmönster`,
    },
  });

  return (
    <RadioButtons
      legend={t`Frekvens`}
      errorMessage={errors.frequency?.message}
      orientation="horizontal"
    >
      <RadioButton
        label={{ text: t(activityFrequencyDictionary.oneTime) }}
        {...frequencyField}
        value={activityFrequencySchema.enum.oneTime}
        visualStyle="framed"
      />
      <RadioButton
        label={{ text: t(activityFrequencyDictionary.recurring) }}
        {...frequencyField}
        value={activityFrequencySchema.enum.recurring}
        visualStyle="framed"
      />
    </RadioButtons>
  );
};
